import type { Env, PayloadData, ServerLocation, ServiceType } from './types'

export const ENV_BASE_URL_MAP: Record<Exclude<Env, 'prod'>, Record<ServiceType, string>> = {
  dev: {
    auth: 'https://pfgatewayt.transsion.com',
    perm: 'https://pfgatewayt.transsion.com',
  },
  sit: {
    auth: 'https://pfgatewayidct.transsion.com',
    perm: 'https://pfgatewayidct.transsion.com',
  },
  uat: {
    auth: 'https://pfgatewayuat.transsion.com',
    perm: 'https://pfgatewayuat.transsion.com',
  },
}

export const PROD_BASE_URL_MAP: Record<ServiceType, Record<ServerLocation, string>> = {
  auth: {
    hk: 'https://pfgateway.transsion.com:9199',
    in: 'https://oneworksin.transsion.com:9099',
    fra: 'https://pfgatewayfra.transsion.com:9199',
    sz: 'https://pfgatewaysz.transsion.com:9199',
    ee1: 'https://pfgatewayee1.transsion.com',
    oci: 'https://pfgatewayin.transsion.com',
  },
  perm: {
    hk: 'https://pfgateway.transsion.com:9199',
    in: 'https://oneworksin.transsion.com:9099',
    fra: 'https://pfgatewayfra.transsion.com:9199',
    sz: 'https://pfgatewaysz.transsion.com:9199',
    ee1: 'https://pfgatewayee1.transsion.com',
    oci: 'https://pfgatewayin.transsion.com',
  },
}

export const LOGIN_CALLBACK_QUERIES: (keyof PayloadData)[] = [
  'token',
  'rtoken',
  'utoken',
  'employeeNo',
  'lang',
  'expiresIn',
]

export const HEADER_AUTH = 'P-Auth'

export const HEADER_RTOKEN = 'P-Rtoken'

export const HEADER_APPID = 'P-Appid'

export const HEADER_LANGID = 'P-Langid'

export const HEADER_EMP_NO = 'P-EmpNo'

export const HEADER_SYS_CODE = 'P-SysCode'

export const HEADER_REQUEST_ID = 'P-RequestId'

export const AUTH_LOGIN_PATH = '/uac-auth-service/v2/api/uac-auth/login/redirect/web-login'

export const AUTH_RTOKEN_CHECK_PATH = '/uac-auth-service/v2/api/uac-auth/rtoken/check'

export const AUTH_RTOKEN_GET_PATH = '/uac-auth-service/v2/api/uac-auth/rtoken/get'

export const AUTH_USER_INFO_PATH = '/uac-auth-service/v2/api/uac-auth/utoken/getUserInfo'

export const AUTH_USER_PAGE_PATH = '/uac-user-service/v2/api/uac-user/user/webPages'

export const AUTH_DEPT_CHILD_PATH = '/uac-org-service/v2/api/uac-org/dept/webChildDepts'

export const AUTH_LOGOUT_PATH = '/uac-auth-service/v2/api/uac-auth/logout'

export const PERM_PERMISSIONS_PATH =
  '/service-unified-permission/unified-permission/IscAuth/getUiRe4Out'

export const PERM_ALL_RESOURCES_PATH =
  '/service-unified-permission/unified-permission/IscAuth/getReByToken4Out'

export const PERM_USER_ROLES_PATH =
  '/service-unified-permission/unified-permission/IscAuth/getRoleByEmpNo4Out'

export const PERM_USER_ROLES2_PATH =
  '/service-unified-permission/unified-permission/IscAuth/getBaseRolesByEmpNo'
